import { RouteEnum } from 'pro/config/routers';
import siteConf from 'pro/config/site';
import Image from '@base/lib/ThemeImage';
import React from 'react';
import styles from '@pro/help/default.module.less';

const VivoSunImg: React.FC = () => {
    return (
        <Image
            src="asset/width-9480/picture/891608928fe96104989a9dc09c7ea82e.png"
            alt={siteConf.brand}
            width={109}
            height={20}
            background={false}
            fixed
        />
    )
}


export default function TermsOfService() {
    return (
        <div className={styles.help}>
            <h1>Geistiges Eigentum</h1>

            <p>Das Folgende <VivoSunImg/> Produkte sind in den USA und anderswo durch Patente geschützt.</p>
            <p>Diese Website ist so konzipiert, dass sie die Bestimmungen verschiedener Jurisdiktionen zur virtuellen Patentkennzeichnung erfüllt, einschließlich der Bestimmungen des America Invents Act zur virtuellen Patentkennzeichnung, und um Hinweise gemäß 35 USC §287 (a) des United States Patent Act bereitzustellen. </p>
            <p>Das <VivoSunImg/> Die unten aufgeführten Produkte und zugehörigen US-Patente erheben möglicherweise keinen Anspruch auf Vollständigkeit. Beispielsweise können einige der hier aufgeführten Produkte in den Vereinigten Staaten und anderen Ländern durch Patente geschützt sein, und für andere Produkte, die hier nicht aufgeführt sind, können in den USA und anderen Ländern ein oder mehrere Patente gelten.</p>
            <p>Die unten aufgeführten Produkte sind durch ein oder mehrere US-Patente geschützt. Weitere Patente können in den Vereinigten Staaten oder anderswo anhängig sein.</p>

            <h2>Produkt</h2>

            <p><VivoSunImg/> AeroWave A6 Clip-on Fan</p>
            <p>
                Protected by U.S. Patent No.: <br/>
                US29,777,109<br/>
                US17,815,577<br/>
                US16,896,274<br/>
            </p>

            <p><VivoSunImg/> AeroWave E6 Cilp on Fan</p>
            <p>
                Protected by U.S. Patent No.:<br/>
                US17,815,577<br/>
                US16,896,274<br/>
            </p>



        </div>
    )
};